import React from "react";
import "./HomeCollectionCss/HomeCollectionSummaryModal.css";
import { convertToDDMMYYYY } from "../../utils/helper";

const HomeCollectionSummaryModal = ({ open, onClose, onBook, details }) => {
  if (!open) return null;
  console.log("Details:", details); // For debugging purposes

  return (
    <div className="modal-backdrop">
      <div className="modal-container">
        {/* Header */}
        <div className="modal-header">
          <h2>
            Home Collection Request Summary{" "}
            <span className="price">
              (Price Rs. {details?.totalPrice ?? ""})
            </span>
          </h2>
          <button className="close-btn" onClick={onClose}>
            ×
          </button>
        </div>

        {/* Personal Information */}
        <div className="section">
          <div className="home-collection-title">Personal Information</div>
          <div className="grid">
            <p>
              <b>Name:</b> {details?.PFirstName} {details?.PLastName} (
              {details?.PSex})
            </p>
            <p>
              <b>D.O.B:</b>{" "}
              {details?.dateofbirth
                ? new Date(details.dateofbirth).toLocaleDateString("en-GB")
                : "N/A"}
            </p>

            <p>
              <b>Email:</b> {details?.email}
            </p>
            <p>
              <b>Mobile:</b> {details?.mobile_no}
            </p>
            <p>
              <b>Alt No.:</b> {details?.altPhone}
            </p>
            <p>
              <b>Address:</b> {details?.address}
            </p>
            <p>
              <b>State:</b> {details?.State}
            </p>
            <p>
              <b>City:</b> {details?.City}
            </p>
            <p>
              <b>Landmark:</b> {details?.landmark}
            </p>
            <p>
              <b>Pincode:</b> {details?.Zipcode}
            </p>
          </div>
        </div>

        {/* Appointment Information */}
        <div className="section">
          <div className="home-collection-title">Appointment Information</div>
          <div className="grid">
            <p>
              <b>Time:</b> {details?.preferredTime}
            </p>
            <p>
              <b>Date:</b> {convertToDDMMYYYY(details?.preferredDate)}
            </p>
            <p>
              <b>Referral:</b> {details?.ref_doctor || "Self"}
            </p>
            <p>
              <b>Speciality:</b> {details?.specialization || "N/A"}
            </p>
            <p>
              <b>Prescription:</b>{" "}
              {details?.prescription ? details.prescription.name : "N/A"}
            </p>

            <div className="selected-test">
              <b>Selected Test:</b>
              <span className="chip">{details?.testName}</span>
            </div>
          </div>
        </div>

        {/* Footer Buttons */}
        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={onClose}>
            Change
          </button>
          <button className="btn btn-primary" onClick={onBook}>
            Book Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default HomeCollectionSummaryModal;
